import { Menu, Search } from 'lucide-react';

import { useUiStore } from '@/store/ui';
import { AreaFilterBar } from '@/app/layout/AreaFilterBar';
import { useSuche } from '@/modules/suche/sucheStore';
import { Glocke } from '@/modules/benachrichtigungen/Glocke';
import { SyncSymbol } from '@/modules/sync/SyncSymbol';

export function Topbar() {
  const setOpen = useUiStore((s) => s.setSidebarOpen);
  const sucheOeffnen = useSuche((s) => s.oeffnen);

  return (
    <header className="sticky top-0 z-20 flex min-h-14 flex-wrap items-center gap-3 border-b border-line bg-canvas/85 px-4 py-2 backdrop-blur sm:px-6">
      <button
        type="button"
        aria-label="Menü"
        onClick={() => setOpen(true)}
        className="grid size-9 shrink-0 place-items-center rounded-md text-ink-muted hover:bg-surface-raised hover:text-ink md:hidden"
      >
        <Menu className="size-5" />
      </button>

      <AreaFilterBar />

      {/* Suche von jeder Seite (F-18) - am Handy ohne Umweg ueber das Menue. */}
      <button
        type="button"
        aria-label="Suchen (Strg+K)"
        title="Suchen (Strg+K)"
        onClick={() => sucheOeffnen()}
        className="ml-auto grid size-9 shrink-0 place-items-center rounded-md text-ink-muted hover:bg-surface-raised hover:text-ink"
      >
        <Search className="size-4" />
      </button>

      {/* Synchronisierung (T-04, F-44) - immer sichtbar, Details beim Antippen. */}
      <SyncSymbol />

      {/* Benachrichtigungszentrale (F-30). */}
      <Glocke />
    </header>
  );
}
